import { render, staticRenderFns } from "./ItemBoxConnected.vue?vue&type=template&id=7795bb7c&"
import script from "./ItemBoxConnected.vue?vue&type=script&lang=js&"
export * from "./ItemBoxConnected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports